import React from "react";
import RoutesCards from "../../../Components/RoutesCard";
import { routesData } from "../../../logics/Data";

const EventsCard = () => {
  return (
    <div className="row pb-3">
      {routesData.map((value) => {
        return (
          <section
            key={value.id}
            className="col-lg-3 col-md-4 col-sm-6 col-12 my-2"
          >
            <RoutesCards value={value} />
          </section>
        );
      })}
    </div>
  );
};

export default EventsCard;
